import { render, staticRenderFns } from "./TicketPriceListSM.vue?vue&type=template&id=328004df"
import script from "./TicketPriceListSM.vue?vue&type=script&setup=true&lang=ts"
export * from "./TicketPriceListSM.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TicketPriceListSM.vue?vue&type=style&index=0&id=328004df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports